<div [formGroup]="group" [ngClass]="{ 'form-group--checkmark': control.isValid }">
  <ng-container [ngSwitch]="control.type">
    <ng-container *ngSwitchCase="formType.date">
      <input
        type="text"
        class="form-control"
        (keyup)="dateInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [attr.name]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      />
    </ng-container>
    <ng-container *ngSwitchCase="formType.postalCode">
      <input
        type="text"
        class="form-control"
        (blur)="postcodeInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [attr.name]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      />
    </ng-container>
    <ng-container *ngSwitchCase="formType.phoneNumber">
      <input
        type="tel"
        class="form-control"
        [ngClass]="{ 'form-control--verified': isVerified, 'form-control--unverified': isUnverified }"
        (blur)="phoneNumberInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [attr.name]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      />
    </ng-container>
    <ng-container *ngSwitchCase="formType.numberOnly">
      <input
        type="text"
        class="form-control"
        (blur)="numberOnlyInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [attr.name]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      />
    </ng-container>
    <ng-container *ngSwitchDefault>
      <input
        [type]="control.type"
        class="form-control"
        (blur)="config.trim ? trimTrailSpace($event) : null"
        (change)="onChange($event)"
        [ngClass]="{ 'form-control--verified': isVerified, 'form-control--unverified': isUnverified }"
        [formControlName]="config.name"
        [attr.name]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
      />
    </ng-container>
  </ng-container>

  <div *ngIf="showVerification" class="form-control__badge" [ngClass]="{ 'form-control__badge--verified': isVerified }">
    <button *ngIf="isUnverified" (click)="verify($event)" type="button" class="badge badge--button">
      <span>{{ control.verifyLabel ?? ("account.label.verify" | translate) }}</span>
      <span class="icon icon-ui-arrow--right--sm"></span>
    </button>
    <span *ngIf="isVerified" class="badge badge--green">
      {{ "account.label.verified" | translate }}
    </span>
  </div>
</div>
